import { Component, OnInit,ViewChild } from '@angular/core';
import { SiteService } from '../site/site.service';
import { UserManagementService } from '../user-management/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-site-user-nav',
    templateUrl: './site-user-nav.component.html',
    styleUrls: ['./site-user-nav.component.css'],
    standalone: false
})
export class SiteUserNavComponent implements OnInit {
  private storage = environment.storage;
  @ViewChild('content') content;
  @ViewChild('picker') picker: any;
  public dateRange: any;
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public user: any;
  allocatedSite:any;
  public siteinfo:any;
  pdfurl:any;
  sitename:any;
  periodicDateRange : any;
  modelref : any;
  data: any;
  loading = 0;
  constructor( private router: Router,private userService: UserManagementService,private siteService: SiteService,private modalService: NgbModal) { }

  ngOnInit(): void {
    const allSites = this.userService.getSiteDetail();
    this.user = this.userService.getUserDetail();
    this.siteinfo=this.userService.getSiteDetail();
    if(allSites?.length){
      this.allocatedSite = allSites[0].site_id;
      this.pdfurl = this.siteService.getPDFUrl(this.siteinfo[0].sitepfd);
      this.sitename=this.siteinfo[0].site_name;
    }
  }

  logout() {
    // Clear filter selections before logout
    this.clearAllFilterSelections();
    
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
  }

  private clearAllFilterSelections(): void {
    try {
      const allKeys = Object.keys(localStorage);
      const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
      
      filterKeys.forEach(key => {
        localStorage.removeItem(key);
        console.log(`✅ Site User Nav: Cleared filter selection for key: ${key}`);
      });
      
      console.log(`🎉 Site User Nav: Cleared ${filterKeys.length} filter selections`);
    } catch (e) {
      console.error('❌ Error clearing filter selections in site-user-nav:', e);
    }
  }

}
